import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BasisSystemBugtrackerService } from '@zaoblako/web/core/services/basis/basis-system-bugtracker.service';
import { TooltipModule } from 'primeng/tooltip';
import { BugtrackerSupportFormInterface } from '@zaoblako/shared/modules/bugtracker/dtos/bugtracker-support.form.dto';
import { ButtonComponent } from '@zaoblako/web/shared/dumbs/button/button.component';
import { DialogModule } from 'primeng/dialog';
import { SpinnerComponent } from '@zaoblako/web/shared/dumbs/spinner/spinner.component';
import { EditorComponent } from '@zaoblako/web/shared/dumbs/editor/editor.component';
import { ErrorService } from '@zaoblako/web/core/services/error.service';
import { AuthService } from '@zaoblako/web/core/services/security/auth.service';
import { BadgeModule } from 'primeng/badge';
import { MessagesModule } from 'primeng/messages';
import { ProfileService } from '@zaoblako/web/core/services/security/profile.service';

@Component({
  selector: 'crm-support-modal',
  standalone: true,
  imports: [
    CommonModule,
    TooltipModule,
    ButtonComponent,
    DialogModule,
    SpinnerComponent,
    EditorComponent,
    BadgeModule,
    MessagesModule
  ],
  templateUrl: './support-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SupportModalComponent implements OnInit {
  public isShowModal = false;
  public loading = false;
  public form: BugtrackerSupportFormInterface = {
    module: '',
    page: '',
    description: '',
    name: '',
    email: ''
  };

  public isAccess = signal<boolean>(false);

  @Input() public isLk = false;

  public constructor(
    private readonly basisSystemBugtrackerService: BasisSystemBugtrackerService,
    public readonly authService: AuthService,
    private readonly profileService: ProfileService,
    private readonly cdRef: ChangeDetectorRef,
    private readonly errorService: ErrorService
  ) {}

  public ngOnInit() {
    this.profileService.hasProfileAccessToAdminTenant({ email: this.authService.currentProfile?.email }).subscribe({
      next: (result) => {
        this.isAccess.set(result.access);
      }
    });
  }

  public openModal() {
    this.isShowModal = true;
    this.loading = true;
    setTimeout(() => {
      this.loading = false;
      this.cdRef.markForCheck();
    });
  }

  public closeModal() {
    this.form.description = '';
  }

  public save() {
    if (!this.form.description?.length) {
      this.errorService.addCustomError('Не все поля заполнены');
      return;
    }

    this.loading = true;
    this.cdRef.markForCheck();

    this.form.page = location.href;
    this.form.name = this.authService.currentProfile?.name;
    this.form.email = this.authService.currentProfile?.email;

    const path = location.pathname.split('/')[1];
    switch (path) {
      case 'user': {
        this.form.module = 'Пользователи';
        break;
      }
      case 'client': {
        this.form.module = 'Клиенты';
        break;
      }
      case 'company': {
        this.form.module = 'Компании';
        break;
      }
      case 'directory': {
        this.form.module = 'Справочники';
        break;
      }
      case 'payments': {
        this.form.module = 'Платежи';
        break;
      }
      case 'deal': {
        this.form.module = 'Сделки';
        break;
      }
      case 'notification': {
        this.form.module = 'Уведомления';
        break;
      }
      case 'document': {
        this.form.module = 'Документы';
        break;
      }
      case 'project': {
        this.form.module = 'Задачи';
        break;
      }
      case 'budget': {
        this.form.module = 'Бюджетирование';
        break;
      }
      case 'debts': {
        this.form.module = 'Задолженности';
        break;
      }
      case 'helpdesk': {
        this.form.module = 'HelpDesk';
        break;
      }
      case 'purchase': {
        this.form.module = 'Закупки';
        break;
      }
      case 'ofd': {
        this.form.module = 'ОФД';
        break;
      }
      case 'control': {
        this.form.module = 'Пропуска';
        break;
      }
      case 'traffic': {
        this.form.module = 'Трафик';
        break;
      }
      case 'passage': {
        this.form.module = 'Паркинг';
        break;
      }
      case 'lk': {
        this.form.module = 'ЛК';
        break;
      }
      default: {
        this.form.module = 'Неизвестно';
        break;
      }
    }

    if (location.pathname === '/') {
      this.form.module = 'Рабочий стол';
    }

    this.basisSystemBugtrackerService.support(this.form).subscribe({
      next: () => {
        this.errorService.addSuccessMessage('Обращение отправлено');
        this.isShowModal = false;
        this.loading = false;
        this.cdRef.markForCheck();
      },
      error: () => {
        this.loading = false;
        this.cdRef.markForCheck();
      }
    });
  }

  public redirectToLk() {
    this.profileService
      .getAvailableTenants()
      .subscribe(({ asExternalUser }) => {
        const currentTenantByMainDomain = asExternalUser.find((tenant) => tenant?.subdomain === location.hostname);
        const tenant = currentTenantByMainDomain || asExternalUser.find((item) => !!item?.personalAccountSubdomain);
        if (tenant?.personalAccountSubdomain) {
          window.open(`https://${tenant.personalAccountSubdomain}/lk/external-user/hd/list`, '_blank');
        }
      });
  }
}
